<script>
  import { currentRoute, navigate } from '../routes.js';
  import { t } from '../services/i18n.js';

  const navItems = [
    { route: 'catalog' },
    { route: 'about' },
    { route: 'contact' }
  ];
</script>

<nav class="navigation" aria-label="Navegação principal">
  <ul class="nav-list">
    {#each navItems as item}
      <li>
        <a
          href="/{item.route === 'catalog' ? '' : item.route}"
          class="nav-link"
          class:active={$currentRoute === item.route || ($currentRoute === 'home' && item.route === 'catalog')}
          onclick={(e) => { e.preventDefault(); navigate(item.route); }}
          aria-current={$currentRoute === item.route ? 'page' : undefined}
        >
          {$t(`nav.${item.route}`)}
        </a>
      </li>
    {/each}
  </ul>
</nav>

<style>
  .navigation {
    background-color: var(--color-surface);
    border-bottom: 1px solid var(--color-border);
  }

  .nav-list {
    max-width: var(--max-width);
    margin: 0 auto;
    padding: 0 var(--spacing-lg);
    display: flex;
    gap: var(--spacing-xs);
    list-style: none;
    overflow-x: auto;
    scrollbar-width: none;
  }

  .nav-list::-webkit-scrollbar {
    display: none;
  }

  .nav-link {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: var(--spacing-md) var(--spacing-lg);
    color: var(--color-text-secondary);
    text-decoration: none;
    font-weight: 500;
    white-space: nowrap;
    border-bottom: 2px solid transparent;
    transition: all var(--transition-fast);
  }

  .nav-link:hover {
    color: var(--color-primary);
    background-color: var(--color-primary-alpha);
  }

  .nav-link.active {
    color: var(--color-primary);
    border-bottom-color: var(--color-secondary);
    font-weight: 600;
  }

  .nav-icon {
    font-size: 1.125rem;
  }

  @media (max-width: 768px) {
    .nav-list {
      padding: 0 var(--spacing-md);
    }

    .nav-link {
      padding: var(--spacing-sm) var(--spacing-md);
      flex-direction: column;
      gap: 2px;
    }

    .nav-label {
      font-size: 0.75rem;
    }
  }
</style>
